import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {
  PollResult,
  ToolExecuteParams,
  ToolResult,
} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {poll} from 'common/src/modules/shared/copilot/utils/poll';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {AccountAnalyticsToolName} from '../accountAnalyticsAgent.enums';

function navigateToAccountDashboardTool(store: CLStore) {
  const inputSchema = z.object({});

  async function execute({
    toolUtils: {logger},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const {
      dashboardPage: {dashboardId},
    } = store.getState();

    function _isMounted(): PollResult {
      const state = store.getState();
      const {dashboardPage} = state;

      if (dashboardPage.dashboards.length) {
        return {passed: true};
      }

      return {passed: false, reason: 'You are not on the dashboard page'};
    }

    if (dashboardId) return toolResult('Success');

    routingService.goTo({
      url: Routes.Dashboard,
    });

    await poll({
      checkFn: _isMounted,
      maxAttempts: 30,
      interval: 100,
      logger,
    });

    return toolResult('Success');
  }

  return tool({
    name: AccountAnalyticsToolName.NavigateToAccountDashboard,
    displayName: 'Navigating to account dashboard',
    description: 'navigate to the account dashboard page',
    execute,
    inputSchema,
  });
}

export default navigateToAccountDashboardTool;
